import React,{Component,Fragment} from 'react';
import {nutritions, updatedNutritions} from './../../../server/constants.js';
import {allowNumericWithdecimal, convertTwoDecimalPoint } from './../../../server/util.js'

class NutritionCtrl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: false
        }
    }
    render(){
        return(<Fragment>
        <div className="row" style={{marginTop:'10px'}}>
            <div className="col-md-12">
                <h4 className="sub-title text-danger" style={{marginBottom:'10px'}} >{'Nutrition Info'}</h4>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12 " style={{fontSize:'12px'}}>
            <ul class="list-group row">
                {          
                Object.keys(updatedNutritions).map((item,k)=>{
                    return (
                    <li class="list-group-item col-xs-4" style={{ padding:"5px 15px", border:'0'}}>
                        <span style={{paddingLeft:'5px', paddingRight:'5px'}}>{updatedNutritions[item].display} : </span>
                        <label className="control-label">{ this.props.data[item]||''}</label>
                  </li>)
                })
            }   
            </ul>             
           </div></div>

        </Fragment>);
    }
}
export default NutritionCtrl


// WEBPACK FOOTER //
// ./src/components/Parent/ManageOrders/nutritionCtrl.js